// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2u1Tt","col":"Table_col__1QvLo","fulfillmentStatus":"Table_fulfillmentStatus__3ux4v","emailCol":"Table_emailCol__3b7H7"};